var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _g, _polygon10, _g2, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 912.3 954.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #dea63b;\n      }\n\n      .st2 {\n        fill: #bf8c2e;\n      }\n\n      .st3 {\n        fill: #e0528f;\n      }\n\n      .st4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st5 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st6 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st7 {\n        fill: #ff3b1f;\n      }\n\n      .st8 {\n        fill: #57bf2b;\n      }\n\n      .st9 {\n        fill: #de1266;\n      }\n\n      .st10 {\n        fill: #0078b5;\n      }\n\n      .st11 {\n        fill: #fc6926;\n      }\n\n      .st12 {\n        fill: #26bde3;\n      }\n\n      .st13 {\n        fill: #fc9e24;\n      }\n\n      .st14 {\n        fill: #1a476b;\n      }\n\n      .st15 {\n        fill: #e5243b;\n      }\n\n      .st16 {\n        fill: #407d45;\n      }\n\n      .st17 {\n        fill: #4d9e38;\n      }\n\n      .st18 {\n        fill: #c21729;\n      }\n\n      .st19 {\n        fill: #a31a42;\n      }\n\n      .st20 {\n        fill: #0a96d9;\n      }\n\n      .st21 {\n        fill: #fcc20a;\n      }\n\n      .st22 {\n        clip-path: url(#clippath);\n      }\n\n      .st23 {\n        fill: #00699e;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3573.44,
    y: -5495.3,
    width: 1567.75,
    height: 1640.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3573.44,
    y: -5495.3,
    width: 1567.75,
    height: 1640.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 912.3,
    height: 954.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 912.3,
    height: 954.68
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "4698.39 -4307.49 4697.81 -4765.18 4605.3 -4818.4 4605.24 -4531.47 4605.23 -4531.47 4605.34 -4420.29 4605.31 -4420.28 4605.35 -4361.12 4210.83 -4133.03 4210.61 -4025.48 4698.39 -4307.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "3573.44 -4957.4 3573.84 -4392.52 4210.61 -4025.48 4210.62 -4025.48 4210.83 -4133.03 4210.75 -4132.99 3666.8 -4446.53 3666.48 -4903.77 3720.05 -4934.75 3720.04 -5042.17 3573.44 -4957.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "3867.53 -5127.4 3867.93 -4562.41 4263.89 -4334.17 4356.99 -4388.1 4108.39 -4531.4 4108.39 -4531.41 4015.35 -4585.06 4015.35 -4585.03 3960.7 -4616.53 3960.42 -5073.75 3867.55 -5127.41 3867.53 -5127.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "4503.73 -5495.3 4356.44 -5410.13 4260.48 -5354.63 3867.55 -5127.41 3960.41 -5073.75 4503.95 -5387.99 4900.22 -5159.58 4900.26 -5096.66 4993.12 -5043.13 4993 -5213.28 4503.73 -5495.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "4209.54 -4195.21 4605.32 -4424.23 4605.23 -4531.47 4357.15 -4388.01 4262.97 -4333.54 4209.68 -4302.73 3813.23 -4531.29 3720.45 -4477.36 4209.54 -4195.21"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4845.77 -4787.5 4449.72 -5015.79 4356.44 -4961.96 4605.3 -4818.51 4605.3 -4818.4 4701.81 -4762.97 4701.77 -4762.9 4752.99 -4733.38 4753.3 -4276.25 4753.27 -4276.24 4846.16 -4222.69 4845.77 -4787.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "4503.86 -5217.53 5047.77 -4904.03 5140.78 -4958.02 4993.11 -5043.13 4900.26 -5096.66 4504.08 -5325.04 4503.86 -5217.53"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5047.76 -4904.03 5048.15 -4446.76 4993.69 -4415.26 4993.74 -4307.86 5141.19 -4393.13 5140.8 -4958.02 5047.76 -4904.03"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4993.84 -4137.55 4993.72 -4307.85 4993.73 -4307.86 4993.62 -4418.13 4993.65 -4418.13 4993.3 -4872.78 4900.3 -4818.7 4900.8 -4191.15 4993.84 -4137.55"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "4993.83 -4137.49 4993.84 -4137.49 4993.84 -4137.5 4993.83 -4137.49"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "4504.99 -3962.23 4449.33 -3994.29 4356.12 -3940.44 4504.84 -3854.72 4993.79 -4137.47 4900.73 -4191.08 4504.99 -3962.23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M4504.05-5047.16l.16-107.51-.05-.03c-131.82,76.23-264.28,152.93-396.04,229.13l.04,106.9,248.29-143.29.32.18,92.98-54.01h-.02s54.29-31.41,54.29-31.41l.04.03Z"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "4504.29 -5154.6 4504.04 -5047.15 4900.3 -4818.7 4993.29 -4872.77 4504.29 -5154.6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M4108.16-4816.57l-.02-109.01s-.02.01-.03.02l-.04-63.07-.03.04-93.01-53.61.32,457.15,93.04,53.66-.2-285.17h-.03Z"
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "4015.03 -5042.27 4015.03 -5042.21 4108.1 -4988.67 4108.07 -4988.65 4503.86 -5217.53 4504.08 -5325.04 4015.03 -5042.27"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4846.1 -4222.76 4753.27 -4276.24 4209.93 -3963.41 4209.78 -3855.89 4357.3 -3941.14 4450.43 -3995.06 4846.1 -4222.76"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "4209.92 -3963.41 4209.92 -3963.41 3813.57 -4191.87 3813.49 -4254.33 3720.48 -4307.89 3720.61 -4137.86 4209.78 -3855.89 4209.92 -3963.41"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "3719.85 -5212.31 3719.85 -5212.18 3812.79 -5158.83 4208.52 -5387.68 4263.21 -5356.15 4356.3 -5410.09 4208.85 -5495.08 3719.85 -5212.31"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "3719.85 -5212.31 3720.06 -5044.41 3720.07 -5044.41 3720.08 -4934.7 3720.13 -4934.73 3720.46 -4477.36 3813.23 -4531.29 3812.79 -5158.83 3719.85 -5212.31"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "654.62 691.2 654.29 424.87 600.45 393.89 600.42 560.86 600.41 560.87 600.48 625.56 600.46 625.57 600.48 660 370.9 792.72 370.77 855.31 654.62 691.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "0 313.01 .23 641.72 370.77 855.31 370.78 855.31 370.9 792.72 370.86 792.74 54.33 610.29 54.14 344.22 85.31 326.19 85.31 263.68 0 313.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "171.13 214.09 171.36 542.86 401.78 675.68 455.96 644.29 311.29 560.9 311.29 560.9 257.15 529.68 257.15 529.7 225.35 511.37 225.18 245.31 171.15 214.08 171.13 214.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "541.35 0 455.64 49.56 399.8 81.86 171.15 214.08 225.18 245.31 541.47 62.44 772.07 195.36 772.09 231.97 826.13 263.12 826.06 164.11 541.35 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "370.15 756.54 600.46 623.27 600.41 560.87 456.05 644.35 401.24 676.04 370.24 693.97 139.54 560.97 85.55 592.35 370.15 756.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "740.38 411.88 509.91 279.03 455.64 310.36 600.45 393.83 600.45 393.89 656.61 426.15 656.59 426.19 686.39 443.37 686.57 709.38 686.56 709.39 740.61 740.55 740.38 411.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "541.42 161.64 857.93 344.06 912.06 312.65 826.13 263.12 772.09 231.97 541.55 99.07 541.42 161.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "857.93 344.06 858.15 610.16 826.46 628.49 826.49 690.99 912.3 641.37 912.06 312.65 857.93 344.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "826.55 790.09 826.48 690.99 826.49 690.99 826.42 626.82 826.44 626.82 826.23 362.25 772.11 393.72 772.41 758.9 826.55 790.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "826.54 790.13 826.55 790.12 826.55 790.12 826.54 790.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "542.08 892.11 509.69 873.46 455.45 904.79 541.99 954.68 826.52 790.14 772.36 758.94 542.08 892.11"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M541.53,260.78l.09-62.56-.03-.02c-76.71,44.36-153.79,88.99-230.46,133.33l.02,62.21,144.49-83.38.18.11,54.11-31.43h-.01s31.59-18.28,31.59-18.28l.03.02Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "541.67 198.26 541.53 260.78 772.11 393.72 826.23 362.26 541.67 198.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M311.16,394.96v-63.44s-.02,0-.03.01l-.03-36.7-.02.02-54.12-31.2.19,266.02,54.14,31.22-.12-165.94h-.02Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "256.96 263.62 256.96 263.66 311.12 294.81 311.11 294.83 541.42 161.63 541.55 99.08 256.96 263.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "740.58 740.51 686.56 709.39 370.38 891.43 370.29 954 456.14 904.39 510.33 873.01 740.58 740.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "370.38 891.43 370.38 891.43 139.73 758.48 139.69 722.13 85.56 690.97 85.64 789.91 370.29 954 370.38 891.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "85.2 164.68 85.2 164.75 139.28 195.79 369.56 62.63 401.38 80.97 455.56 49.58 369.75 .12 85.2 164.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "85.2 164.68 85.32 262.38 85.32 262.38 85.33 326.22 85.36 326.2 85.55 592.35 139.54 560.97 139.28 195.79 85.2 164.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactHexagon);
export default __webpack_public_path__ + "static/media/impact-hexagon.474c337136a632892c1a218b00f0935d.svg";
export { ForwardRef as ReactComponent };